enum ActionTypes {
    REGISTER_SUCCESS = 'REGISTER_SUCCESS',
    REGISTER_FAIL = 'REGISTER_FAIL',
    LOGIN_SUCCESS = 'LOGIN_SUCCESS',
    LOGIN_FAIL = 'LOGIN_FAIL',
    LOGOUT = 'LOGOUT',
    UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS',

    SET_MESSAGE = 'SET_MESSAGE',
    CLEAR_MESSAGE = 'CLEAR_MESSAGE',
}

export default ActionTypes;
